<div [class]="field.styleValue" [attr.lang]="metadataValue.language">
  <div class="d-flex align-items-center identifier-container-{{iconPosition}}">
    <a href="{{iconLink}}" [ngbTooltip]="iconLink" target="_blank" *ngIf="subTypeIcon && iconPosition !== iconPositionEnum.NONE">
      <img class="source-icon" [src]="subTypeIcon" alt="source-icon" >
    </a>
    <span class="text-value">
      <a [target]="target" href="{{identifier?.href}}">{{ identifier?.text }}</a>
    </span>
  </div>
</div>
